import { faFacebook } from '@fortawesome/free-brands-svg-icons/faFacebook'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import React, { useMemo } from 'react'
import { useMeasure } from 'react-use'

import { CM_FB_VENDOR, CM_TWITTER_VENDOR } from '@/config/constants'

import xTwitter from '../../../../data/global_static/images/x-logo-black.png'
import { TabPager } from '../../generic'
import SimpleIcon from '../../generic/components/SimpleIcon'
import PropTypesHelpers from '../../utils/propTypesHelpers'

export const FacebookWidget = ({ info }) => {
  const [ref, { width }] = useMeasure()

  return (
    <div ref={ref} className='facebook-widget'>
      <iframe
        className='cmplazyload'
        data-cmp-src={`https://www.facebook.com/plugins/page.php?href=${encodeURIComponent(info)}&tabs=timeline&width=${Math.floor(width)}&height=500&small_header=true&adapt_container_width=true&hide_cover=true&show_facepile=true`}
        src='about:blank'
        data-cmp-vendor={CM_FB_VENDOR}
        width='100%'
        height={500}
        style={{ border: 'none', overflow: 'hidden' }}
        scrolling='no'
        frameBorder='0'
        allow='encrypted-media'
      />
    </div>
  )
}

FacebookWidget.propTypes = {
  info: PropTypes.string
}

export const TwitterWidget = ({ info }) => {
  return (
    <div className='twitter-timeline-wrapper'>
      <a
        className='twitter-timeline cmplazyload'
        href={`https://twitter.com/${info.toUpperCase()}?ref_src=twsrc%5Etfw`}
        data-width={320}
        data-height={500}
        data-cmp-hide='1'
        data-cmp-vendor={CM_TWITTER_VENDOR}
      >
        {`Tweets by ${info.toUpperCase()}`}
      </a>
      <script
        type='text/plain'
        className='cmplazyload'
        data-cmp-preview='320x500'
        data-cmp-vendor={CM_TWITTER_VENDOR}
        async
        data-cmp-src='https://platform.twitter.com/widgets.js'
      />
    </div>
  )
}

TwitterWidget.propTypes = {
  info: PropTypes.string
}

export const WIDGETS = {
  facebook: {
    icon: faFacebook,
    widget: FacebookWidget
  },
  twitter: {
    icon: xTwitter,
    widget: TwitterWidget,
    customIcon: true
  }
}

export const SocialWidget = ({ type, info, ...props }) => {
  if (!WIDGETS[type]) return null
  const Tag = WIDGETS[type].widget
  return (
    <Tag info={info} {...props} />
  )
}

SocialWidget.propTypes = {
  info: PropTypes.string,
  type: PropTypes.string
}

const TabsContainer = ({ children, ...props }) => (
  <ul
    className='nav nav-tabs-rect' {...props}
  >
    {children}
  </ul>
)

TabsContainer.propTypes = {
  children: PropTypesHelpers.children
}

const Social = ({
  info: {
    social_links: socialLinks = {}
  }
}) => {
  const socialItems = useMemo(() => {
    const items = Object.keys(socialLinks).reduce(
      (socials, type) => {
        if (!WIDGETS[type]) {
          return socials
        }
        return [
          ...socials,
          { type, icon: WIDGETS[type].icon, customIcon: WIDGETS[type].customIcon, info: socialLinks[type] }
        ]
      },
      [])
    return items
  }, [socialLinks])

  if (!socialItems.length) {
    return null
  }

  return (
    <div className='company-profile-social'>
      <TabPager
        items={socialItems}
        tabsContainerTag={TabsContainer}
        tabTag={({ type, icon, active, onClick, customIcon }) => (
          <li className='nav-item'>
            <a
              className={classnames('nav-link', { active }, `text-${type}`)}
              href=''
              onClick={onClick}
            >
              {customIcon
                ? <img
                    src={icon}
                    className='social-custom-icon'
                    width='23'
                    height='23'
                  />
                : <SimpleIcon icon={icon} />}
            </a>
          </li>
        )}
        pageTag={SocialWidget}
      />
    </div>
  )
}

Social.propTypes = {
  info: PropTypes.shape({
    social_links: PropTypes.shape({
      facebook: PropTypes.string,
      twitter: PropTypes.string
    })
  }).isRequired
}

export default Social
